// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#payment-form{min-width:310px;min-width:307px}@media(max-width: 460px){#payment-form{min-width:inherit}}", "",{"version":3,"sources":["webpack://src/components/StripePaymentInput.vue"],"names":[],"mappings":"AAAA,cAAc,eAAe,CAAC,eAAe,CAAC,yBAAyB,cAAc,iBAAiB,CAAC","sourcesContent":["#payment-form{min-width:310px;min-width:307px}@media(max-width: 460px){#payment-form{min-width:inherit}}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
